import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../style/components/languageSelector.css';
import Flag from './Flag';

const LanguageSelector = ({ style }) => {
  const dispatch = useDispatch();
  const locales = useSelector((state) => state.app.locales);
  const selectedLanguage = useSelector((state) => state.app.selectedLanguage);

  const handleLanguageChange = (langCode) => {
    dispatch({ type: `SET_SELECTED_LANGUAGE`, data: langCode });
  };

  return (
    <div className="language-selector" style={{ ...style }}>
      {locales.map((locale) => (
        <button
          key={locale.language}
          className={`language-flag ${selectedLanguage === locale.language ? 'selected' : ''}`}
          onClick={() => handleLanguageChange(locale.language)}
          title={locale.name}
        >
          <Flag countryCode={locale.countryCode} style={{ width: 20, height: 13 }} />
        </button>
      ))}
    </div>
  );
};

export default LanguageSelector;
